import { SpeciesSurveyDataV1 } from '@omniafishing/core';

export const lunkerMinimumLength = (speciesDisplayName: string) => {
  switch (speciesDisplayName) {
    case 'Largemouth Bass':
    case 'Smallmouth Bass':
      return 20;
    case 'Walleye':
      return 28;
    case 'Northern Pike':
      return 35;
    case 'Muskie':
      return 40;
    default:
      return Infinity;
  }
};

export const determineLunkerYear = (
  speciesDisplayName: string,
  speciesData: SpeciesSurveyDataV1['species'][keyof SpeciesSurveyDataV1['species']]
) => {
  const minimumLength = lunkerMinimumLength(speciesDisplayName);
  const currentYear = new Date().getFullYear();
  const surveyYears = Object.keys(speciesData.length_distributions).reverse();
  const yearsToLookForLunkers = surveyYears.filter((year) => {
    const yearNumber = Number(year);
    // Check if the year is within the last 5 years
    return yearNumber >= currentYear - 5 && yearNumber <= currentYear;
  });
  if (yearsToLookForLunkers.length === 0 && surveyYears.length > 0) {
    yearsToLookForLunkers.push(surveyYears[0]);
  }
  const lunkerYear = yearsToLookForLunkers.find((year) =>
    Object.keys(speciesData.length_distributions[year].counts).some(
      (length) => Number(length) >= minimumLength
    )
  );

  return lunkerYear;
};
